import React from 'react';
import { EventHoverCard } from './EventHoverCard';

// Horizontal bar used in month view & the week view's all-day row
export const EventBar = ({ bar, testId }) => {
  const { event: e, startCol, span, lane, contBefore, contAfter } = bar;
  return (
    <EventHoverCard event={e}>
      <button
        type="button"
        onClick={() => e.onClick && e.onClick()}
        className={`h-[18px] mx-0.5 px-1.5 text-left text-[10px] leading-[18px] font-medium truncate text-white hover:brightness-110 transition-[filter]
          ${contBefore ? 'rounded-l-none ml-0' : 'rounded-l'} ${contAfter ? 'rounded-r-none mr-0' : 'rounded-r'}
          ${e.muted ? 'opacity-50 line-through' : ''}`}
        style={{ gridColumn: `${startCol + 1} / span ${span}`, gridRow: lane + 1, background: e.color }}
        data-testid={`${testId}-event-${e.id}`}
      >
        {contBefore && '‹ '}{e.title}
      </button>
    </EventHoverCard>
  );
};
